const shortMonthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Maj',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dec',
];

const fullMonthNames = [
  'Januar',
  'Februar',
  'Marts',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'December',
];

export const getStartOfYear = () => {
  const date = new Date();

  date.setMonth(0);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);

  return date;
};

export const getEndOfYear = () => {
  const date = new Date();

  date.setMonth(11);
  date.setDate(31);
  date.setHours(23, 59, 59, 999);

  return date;
};

export const getMonthName = (date: Date) => fullMonthNames[date.getMonth()];

export const getShortMonthName = (date: Date) => shortMonthNames[date.getMonth()];

export const formatDateInputValue = (date: Date) => {
  const year = date.getFullYear();
  let month: number | string = date.getMonth() + 1;
  let day: number | string = date.getDate();

  if (month < 10) {
    month = `0${month}`;
  }

  if (day < 10) {
    day = `0${day}`;
  }

  return `${year}-${month}-${day}`;
}
